export enum CONTAINER_TYPES {
  GET_CONTAINER_DATA = '@containerContext/GET_CONTAINER_DATA',
  SET_CONTAINER_DATA = '@containerContext/SET_CONTAINER_DATA',
}

export interface ContainerState {
  readonly containerContext: any;
}
